import React from 'react';

import { Copyright } from './Copyright';

export const Footer: React.FC = () =>
{
  return (
    <footer>
      <Copyright />
    </footer>
  );
}